var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"progress-message"},[_vm._v(" "+_vm._s(_vm.uploadingStatus.filesBeingUploaded)+" "+_vm._s(_vm.textFile)+" na fila para enviar / "+_vm._s(_vm.uploadingStatus.overallProgress)+"% concluído ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }